import styled from "styled-components"
import { device } from "breakpoints"
import Link from "components/AvenueLink"
import { getGradient } from "helpers/getGradient"
import { getGradientText } from "helpers/getGradientText"
import { getSolidColor } from "helpers/getSolidColor"

import { Teaser } from "../Teaser"

import { ImageWrapper, InfoWrapper, Title, Excerpt, Tag } from "../Teaser/style"

export const BigTeaserContainer = styled(Teaser)`

  margin-bottom:40px;

  @media ${device.tablet} {
  margin-bottom:0;
  }

  :last-child {
    margin-bottom:0;
  }


  :hover {
    ${Title}{
      color:${props => getSolidColor(props.theme.site)}
    }

    a {
      span{
        ::after{
          display: none;
        }
      }
    }
    a:nth-child(2) {
      span{
        ::after{
          display: block;
        }
      }
    }
  }

  @media ${device.tablet} {
    flex-direction: ${props => (!(props.index & 1) ? "row" : "row-reverse")};
  }

  ${Title} {
    font-weight: 700;
    font-size: 36px;
    color: #000000;
    letter-spacing: -0.38px;
    line-height: 36px;
    margin-bottom: 16px;


    @media ${device.large} {
      font-size: 48px;
      letter-spacing: -0.5px;
      line-height: 42px;
      margin-bottom: 24px;
    }
  }
  ${Excerpt} {
    font-size: 16px;
    color: #4c4d58;
    letter-spacing: -0.12px;
    line-height: 24px;
    margin-bottom: 16px;

    @media ${device.large} {
      font-size: 20px;
      letter-spacing: -0.16px;
      line-height: 30px;
      margin-bottom: 20px;
    }
  }

  ${Tag} {
    order: -1;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 30px;
    text-transform: uppercase;
    margin-bottom: 7px;
    ${props => getGradientText(props.theme.site)}
    
    @media ${device.large} {
      font-size: 20px;
      margin-bottom: 14px;
    }
  }

  ${ImageWrapper} {
    padding-top: 100%;
    margin-bottom: 18px;


    @media ${device.tablet} {
      max-width: 50%;
      padding-top: 50%;
      margin-bottom: 0;
    }
  }

  ${InfoWrapper} {
    padding-right: 0;

    @media ${device.tablet} {
      justify-content:center;
      padding: 25px 25px;
      display: flex;
      height: auto;
    }
    @media ${device.desktop} {
      padding: 20px 80px;
      display: flex;
    }
    @media ${device.large} {
      padding: 0 80px;

    }
  }
`

export const ReadMore = styled(Link)`
  font-weight: 600;
  font-size: 16px;
  color: black;
  letter-spacing: -0.12px;
  line-height: 24px;
  text-transform: capitalize;

  span {
    position: relative;

    :after {
      content: "";
      position: absolute;
      height: 1px;
      width: 100%;
      top: 21px;
      left: 0;
      background-image: ${props => getGradient(props.theme.site)};
      transition: 400ms;
      z-index: 2;
    }
  }

  :nth-child(2) {
    margin-left: 50px;
    z-index: 5;
    position: relative;

    :before {
      content: "";
      position: absolute;
      height: 80%;
      width: 1px;
      top: 5px;
      left: -25px;
      background-color: #d2d4e0;
    }

    :hover {
      span {
        :after {
          display: none !important;
        }
      }
    }
  }

  @media ${device.desktop} {
    font-size: 20px;
    letter-spacing: -0.16px;
    line-height: 30px;
    span {
      :after {
        top: 26px !important;
      }
    }
  }
`
